import type {AnyValidation, ValidationModifier} from 'schemaDefinition/types';
import {isAnyValidation} from './isAnyValidation';

export const asAnyValidation = (
  validationModifier: ValidationModifier,
): AnyValidation | undefined =>
  isAnyValidation(validationModifier) ? validationModifier : undefined;
